import { CSSProperties } from 'react';
import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  FixtureScoreTeamColorBox,
  FixtureScoreTeamInPlayColorBox,
} from '@/components/FixtureScore/FixtureScoreStyledComponents';
import { ARIA_LABEL } from '@/constants/ariaLabel';

const ColorBoxWrapper = styled(Stack)(({ theme }) => ({
  width: '0.53em',
  alignItems: 'center',
}));

interface FixtureScoreTeamBoxProps {
  inPlay?: boolean;
  teamColor?: string;
  homeTeam?: boolean;
}

export const FixtureScoreTeamBox = ({
  inPlay,
  homeTeam,
  teamColor,
}: FixtureScoreTeamBoxProps) => {
  if (inPlay) {
    return (
      <ColorBoxWrapper>
        <FixtureScoreTeamInPlayColorBox
          aria-label={ARIA_LABEL.FIXTURE_SCORE_TEAM_IN_PLAY_COLOR_BOX}
          homeTeam={homeTeam}
          style={
            { '--teamColor': teamColor && `rgb(${teamColor})` } as CSSProperties
          }
        />
      </ColorBoxWrapper>
    );
  }

  return (
    <ColorBoxWrapper>
      <FixtureScoreTeamColorBox
        aria-label='fixture-score-team-color-box'
        style={
          { '--teamColor': teamColor && `rgb(${teamColor})` } as CSSProperties
        }
      />
    </ColorBoxWrapper>
  );
};
